import { Grid2 } from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../GlobalAssets/svg/Delete.svg";
import { DeleteStyles } from ".";

export function DeleteComponent(props) {
  const { title, subTitle, onClick } = props;
  return (
    <Grid2 className={DeleteStyles.deleteContainer}>
      <Grid2 className={DeleteStyles.title}>{title}</Grid2>
      <Grid2 className={DeleteStyles.subtitle}>{subTitle}</Grid2>
      <Grid2 className={DeleteStyles.deleteButtonContainer}>
        <Grid2 className={DeleteStyles.deleteButton} onClick={onClick}>
          <span>Delete</span>{" "}
          <DeleteIcon
            className={`${DeleteStyles.deleteIcon} ${DeleteStyles.deleteIcon1}`}
          />
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
